<app-navbar *ngIf="showNavBar"></app-navbar>
<div class="main">
  <router-outlet #o="outlet"></router-outlet>
</div>
<app-footer *ngIf="showFooter"></app-footer>
